// extracted by mini-css-extract-plugin
module.exports = {"Head":"style_Head__2njGr","Title":"style_Title__1b4Cz","Texts":"style_Texts__1RzHc","Text":"style_Text__9I0Xn"};